






import { Component, Vue, Prop } from 'nuxt-property-decorator';

@Component<DropdownToggler>({
  name: 'DropdownToggler',
})
export default class DropdownToggler extends Vue {
  @Prop({ default: false }) disabled!: boolean;

  get togglerClass(): Record<string, boolean> {
    return {
      'dropdown-toggler': true,
      'dropdown-toggler--disabled': this.disabled,
    };
  }
}
